//josh
var chosenPrice = 0;
var chosenProductID = "";
var joshtest2 = 0;
var joshtest3 = 0;
var joshstrap = Number(0);
var joshcaseback = Number(0);
var previousPrice = 0;
var counter = 0;
var checkStrap = false;
var checkCaseback = false;
function joshprice2() {
  return chosenPrice;
}

function joshprice() {
    var number = "123";
    document.getElementById("joshprice").innerHTML = number;
  	console.log(number);
}


var bottomConHeight;
var currentPanel;
var prevPanel;
var prevPrevPanel;
var nextPanel;
var nextNextPanel;
var backHeight;
var bottomCon = $(".builder-bottom-con");
var leftCon = $(".builder-left-con");
var rightCon = $(".builder-right-con");
var RrightHeight;
var tabParent = $(".builder-right-big-tabs");
var preview = $(".builder-bottom-preview");
var bottomPreviewHeight;
var limit;
var values = {}; 
var currEngravingFont;
var signatureFont ; 

var windowWidth;
$(function(){
	windowWidth = $(window).width();
});


var engravingRatio;
var engravingFont ;

var is35 = false;
var is40 = false;

String.prototype.capitalizeFirstLetter = function() {
	return this.charAt(0).toUpperCase() + this.slice(1);
}

$.fn.hasAttr = function(name) {  
	return this.attr(name) !== undefined;
};




function builderArrows(){

	currentPanel = $(".builder-right-content-each.current").attr("id").match(/\d+/);

	prevPanel = 'panel' + (parseInt(currentPanel) - 1) ;
	/*check for prev PREV panel*/
	prevPrevPanel = '#panel' + (parseInt(currentPanel) - 2) ;

	nextPanel = 'panel' + (parseInt(currentPanel) + 1) ;
	/*check for next NEXT panel*/
	nextNextPanel = '#panel' + (parseInt(currentPanel) + 2) ;
}

function buildEngravingText(index)
{
	text = $("#ea" + index).val();
	if(text)
	{
		font = $("#builder-engraving-form-font" + index).find(".active").html();
		res = text + " - " + font;
		text += " <em> - "+font+"</em>";
		
	}
	else
	{
		text = "<em>Empty</em>";
		res = "";
	}

	if ($(window).width() < 768){
		formSummary = $("#" + $("#ea" + index).attr("data-summary-mobile"));
	} else if ($(window).width() >= 768) {
		formSummary = $("#" + $("#ea" + index).attr("data-summary"));
	}

	formSummary.find("p").html(text);
	values[$("#ea" + index).attr("data-property")] = res;
	return res;
}

function specsImg(){

	$(".builder-bottom-specs-img").slick({
		infinite: false,
		fade: false,
		cssEase: 'linear',
		arrows: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: true,
		onInit: function(slick){
			if (ww < 768) {
				$(".builder-bottom-specs-img-con").hide();
			}
		}
	});
}


function builderEngraving(){
	engravingEach = $(".builder-left-img-engraving-each");
	imgMaxHeight = 750 ;
	currImgHeight = $(".builder-left-img-con img").outerHeight();

	

	// engravingFont = 0.02 * $(".builder-left-img-con img").outerHeight()
	// minFont = 9;
	// maxFont = 16;

	$(".builder-left-img-engraving, .builder-left-img-full").css({
		"height" : $(".builder-left-img-con img").outerHeight(),
		"width" : $(".builder-left-img-con img").outerWidth()
	});

	if (engravingEach.hasClass("ss35")) {
		currEngravingFont = 15; 
		signatureFont = 11;
		is35 = true;
	} else {
		currEngravingFont = 16;
		signatureFont = 12;
		is40 = true;
	}

	engravingRatio = (currImgHeight / imgMaxHeight);
	engravingFont = engravingRatio * currEngravingFont ; 
	engravingEach.css({
		"font-size" : engravingFont + "px"
	});

	// if ((engravingFont < minFont) && (engravingFont < maxFont)){
	// 	engravingEach.css({
	// 		"font-size" : minFont + "px"
	// 	});
	// } 
	// else if ((engravingFont >= minFont) && (engravingFont < maxFont)){
	// 	engravingEach.css({
	// 		"font-size" : engravingFont + "px"
	// 	});
	// }
	// else if ((engravingFont >= minFont) && (engravingFont >= maxFont)){
	// 	engravingEach.css({
	// 		"font-size" : maxFont + "px"
	// 	});
	// }
}

function builderMob(){
	bottomPreviewHeight = preview.outerHeight();
	bottomConHeight = bottomCon.outerHeight();
	backHeight = $(".builder-back").outerHeight();
	rightCurrent = $(".builder-right-content-each.current");
	RrightHeight = $(".builder-right-content").offset().top + rightCurrent.find(".builder-right-title").outerHeight() + rightCurrent.find(".builder-right-sub-tabs").outerHeight();
	leftWidth = leftCon.outerWidth();
	ww = $(window).width();
	wh = $(window).height();

	

	var leftImgTimer;

	if ((ww >= 768) && (ww < 960)){
		$(".builder-left-con, .builder-right-con").css({
			"height" : wh - bottomConHeight - backHeight
		});

		$(".builder-right-content-each:not(#panel6)").css({
			"min-height" : $(".builder-right-con").outerHeight() - rightCurrent.find(".builder-right-title").outerHeight()
		});

		// leftImgTimer = setTimeout(function(){
		// 	$(".builder-left-inner").css({
		// 		"padding-bottom" : bottomPreviewHeight
		// 	});
		// },1000);

} 
else if ((ww >= 768) && (ww >= 960)) {
	$(".builder-left-con, .builder-right-con").css({
		"height" : ""
	});

	$(".builder-right-content-each").css({
		"min-height" : wh - $(".builder-right-big-tabs").outerHeight() - rightCurrent.find(".builder-right-title").outerHeight() - bottomConHeight
	});	


		// clearTimeout(leftImgTimer);
		// $(".builder-left-inner").css({
		// 	"padding-bottom" : ""
		// });

} else if ((ww < 768) && (ww < 960)) {
	$(".builder-left-con, .builder-right-con").css({
		"height" : ""
	});

	$(".builder-right-content-each:not(#panel6)").css({
		"min-height" : ""
	});	

		// clearTimeout(leftImgTimer);
		// $(".builder-left-inner").css({
		// 	"padding-bottom" : ""
		// });
}



if (ww >= 960){
	leftCon.css({
		"height" : wh - bottomConHeight,
		"margin-top" : ""
	});

		// $(".builder-left-img").css({
		// 	"height" : wh - bottomConHeight,
		// 	"width" : "auto"
		// });

$(".builder-right-content").css({
	"padding-top" : ""
});
$(".builder-right-content-each-inner").css({
	"padding-top" : ""
});


$(".builder-left-inner").css({
	"height" : wh - bottomConHeight
});

		// $(".builder-right-options").css({
		// 	"padding-bottom" : 30 + bottomCon.outerHeight()
		// });


$(".builder-left-con, .builder-right-con").css({
	"margin-top" : ""
});
$(".builder-right-con .builder-right-title").css({
	"top" : ""
});

console.log(wh,RrightHeight);
$(".builder-right-options-con").css({
	"height" : wh - RrightHeight - $(".builder-bottom-con").outerHeight(),
	"width" : rightCon.outerWidth()
});



		// if ($(".builder-right-content-each.current").find(".builder-right-options-con").hasClass("jspScrollable")) {
		// 	alert('ho');
		// }

		// var api = rightCurrent.find(".builder-right-options.active").closest('.builder-right-options-con').data('jsp');
		// api.scrollToY(0,false);
		// api.reinitialise();

	}
	else{

		$(".builder-left-inner").css({
			"height" : ""
		});

		preview.css({
			"top" : rightCurrent.find(".builder-right-title").outerHeight() + backHeight,
			"width" : $(".builder-right-con").outerWidth()
		});

		$(".builder-right-content").css({
			"padding-top" : rightCurrent.find(".builder-right-title").outerHeight()
		});
		$(".builder-right-content-each-inner").css({
			"padding-top" : bottomPreviewHeight
		});


		// $(".builder-left-img").css({
		// 	"height" : ""
		// });

$(".builder-left-con, .builder-right-con").css({
	"margin-top" : backHeight
});
$(".builder-right-con .builder-right-title").css({
	"top" : backHeight
});

$(".builder-right-options").css({
	"padding-bottom" : ""
});
}


if ($(window).width() < 768){

	leftCon.css({
		"height" : ""
	});

		// $(".builder-right-con .builder-right-title").css({
		// 	"top" : backHeight
		// });

$(".builder-bottom-buy").css({
	"top" : leftCon.find(".builder-right-title").outerHeight() + backHeight
});

$(".builder-left-con .builder-right-title").css({
	"top" : backHeight
});
$(".builder-left-inner").css({
	"padding-top" : leftCon.find(".builder-right-title").outerHeight() + $(".builder-bottom-buy").outerHeight()
});

$(".builder-left-img-con-inner").css({
	"width" : ww,
	"height" : ww
});

$(".builder-bottom-specs-con, .builder-bottom-models-con").css({
	"width" : "" 
});

}
else{
	$(".builder-left-img-con-inner").css({
		"width" : leftWidth,
		"height" : (wh - bottomConHeight - backHeight) * 0.85
	});
	$(".builder-left-inner").css({
		"padding-top" : ""
	});

	$(".builder-bottom-specs-con, .builder-bottom-models-con").css({
		"width" : ww 
	});

	$(".builder-bottom-buy").css({
		"top" : ""
	});


	$(".builder-left-summary").css({
		"padding-bottom" : ""
	});

	$(".builder-left-inner").css({
		"padding-top" : "",
	});

		// $(".builder-right-con .builder-right-title").css({
		// 	"top" : ""
		// });

$(".builder-help-inner").css({
	"width" : ww,
	"height" : wh 
});

}
}

var check_cookie = Cookies.get('builder_popup');
if(check_cookie == null){
	$(".builder-left-msg").removeClass("hide");
	Cookies.set('builder_popup', '1');
}

$(window).on("load",function(){
	builderMob();
	builderEngraving();
	specsImg();
	var l = 0;
	$(".builder-bottom-models-section-each").each(function(){
		t = $(this);
		t.slick({
			infinite: false,
			fade: false,
			speed: 700,
			cssEase: 'linear',
			arrows: true,
			slidesToShow: 6,
			centerMode: false,
			slidesToScroll: 1,
			dots: false,
			onInit:function(){
				l++;
				if(l == $(".builder-bottom-models-section-each").length)
				{
					if($(window).width() >= 768)
					{
						$(".builder-bottom-models-con .builder-right-engraving-selection span").eq(0).trigger("click");
					}
				}
				
			},
			responsive:[
			{
				breakpoint: 768,
				settings:{
					slidesToShow: 2,
					slidesToScroll: 1,
					speed: 300,
				}
			}
			]
		});
	});

	if ($(window).width() >= 768){
		leftCon.removeClass("hide");
	}
	else{

		leftCon.toggleClass("hide");

		if (leftCon.hasClass("hide")){
			bottomCon.addClass("preview");
		}
	}



	$(".chosen").trigger("click");
	$(".builder-right-big-tabs-each").first().trigger("click");
	$("#ea1").trigger("keyup");
	$(".global-loading-con").addClass("hide");
});

$(window).on("resize",function(){
	
	if ($(window).width() != windowWidth) {
		builderMob();
		builderEngraving();
		if ($(window).width() >= 960){
			

			$(".builder-left-con, .builder-right-con").removeClass("hide");

			tabParent.removeClass("hide");

			if ($(".builder-right-content-each.current").find(".builder-right-options-con").hasClass("jspScrollable")) {

				var RESTARTapi = $('.builder-right-options-con').data('jsp');
				//RESTARTapi.scrollToY(0,false);
				RESTARTapi.reinitialise();
			} 
			else {
				$(".builder-right-content-each.current").find(".builder-right-options-con").jScrollPane();
			}
		}
		else{
			

			if ($(".builder-right-content-each.current").find(".builder-right-options-con").hasClass("jspScrollable")) {
				var Rapi = $('.builder-right-options-con').jScrollPane().data().jsp;

				Rapi.destroy();
				$('.builder-right-options-con').css({
					"width" : "",
					"height" : ""
				});
			}
		}

		if ($(window).width() < 768) {
			if (!($(".builder-left-con").hasClass("hide"))) {
				$(".builder-right-con").addClass("hide");
			} else {
				$(".builder-right-con").removeClass("hide");
				$(".builder-left-con").addClass("hide");
			}

			//$(".builder-bottom-specs-img-con, #bottom-models").hide();
			$("#bottom-models").hide();
			$('.builder-bottom-specs-img').slick('unslick');
			specsImg();
			
			//$(".builder-bottom-con").addClass("preview");
		} else {
			$(".builder-bottom-specs-img-con, #bottom-models").show();

			$(".builder-left-con, .builder-right-con").removeClass("hide");
			$(".builder-bottom-con").removeClass("preview");
		}
	}

});


$(".builder-right-con").on("scroll mousewheel",function(){
	rt = $(".builder-right-con").scrollTop();

	currentPanel = $(".builder-right-content-each.current");
	fixedTop = backHeight + currentPanel.find(".builder-right-title").outerHeight();
	// absTop = currentPanel.find(".builder-right-subhead").outerHeight() + currentPanel.find(".builder-right-title").outerHeight();
	absTop = currentPanel.find(".builder-right-title").outerHeight();
	limit = absTop - bottomPreviewHeight - 5;
});


$(".builder-right-sub-tabs-mobile").on("click",function(){
	$(this).next().toggleClass("open");
});

$(".builder-left-mobile-edit-trigger").on("click",function(){
	if (ww < 768){
		$(".builder-left-mobile-edit").slideToggle();
	}
});



$(".builder-bottom-menu").on("click",function(){
	t = $(this);

	if (ww >= 768){
		t.next().slideToggle({
			direction: "up"
		});
		t.toggleClass("active");

	}

	if ($(".builder-help-con").hasClass("open")){
		$(".builder-help-con, .global-overlay").removeClass("open");
		$(".builder-top-con").removeClass("help");
	}
});


$(".builder-bottom-each").on("click",function(){
	t= $(this);
	builderCon = $(".builder-con");

	if (ww < 768){
		if (t.hasClass("toggleActive")){
			builderCon.find(".toggleActive").next().slideUp();
			builderCon.find(".toggleActive").removeClass("toggleActive");
		}
		else{


			builderCon.find(".toggleActive").next().slideUp();
			builderCon.find(".toggleActive").removeClass("toggleActive");
			t.next().slideDown();

			t.toggleClass("toggleActive");

			if (t.is("#builder-specs-img")){
				$(".builder-bottom-specs-img").slick('setPosition');
			}


		}
	}


});


$(".builder-bottom-specs, .builder-bottom-models").on("click touchstart",function(){


	t = $(this);
	thisId = t.attr("data-id");
	thisPanel = $("#" + thisId);

	toggleHeight = thisPanel.outerHeight();

	maxPanelHeight = wh - bottomConHeight;


	if (ww >= 768)
	{
		if ($(".builder-help-con").hasClass("open")){
			$(".builder-help-con, .global-overlay").removeClass("open");
			$(".builder-top-con").removeClass("help");
		}


		if ($(".builder-bottom-menu").hasClass("active")){
			$(".builder-bottom-menu").next().slideToggle({
				direction: "up"
			});

			$(".builder-bottom-menu").removeClass("active");
		}

		if ($(this).hasClass("open")){
				//*this means, remove everything.//

				bottomCon.css({
					"bottom" : ""
				});

				bottomCon.find(".open").removeClass("open");
				bottomCon.find(".current").removeClass("current");

				$(".global-overlay").removeClass("open");
			}
			else{
				bottomCon.find(".open").removeClass("open");


				t.addClass("open");

				bottomCon.css({
					"bottom" : toggleHeight
				});

				//*For animation sake*//
				setTimeout(function(){
					bottomCon.find(".current").removeClass("current");
					thisPanel.addClass("current");
				},400);

				$(".global-overlay").addClass("open");
			}
		}
	});

// $(".builder-right-sub-tabs li a").on("click touchstart",function(event){
// 	event.preventDefault();
// });



$(".builder-right-sub-tabs li").on("click",function(event){
	t= $(this);
	subPanel = $(t.find("a").attr("href"));
	translateX = (t.offset().left - t.closest(".builder-right-sub-tabs").offset().left) + (t.outerWidth() / 2) - ($(".builder-right-sub-tabs-marker").outerWidth() / 2 );
	event.preventDefault();
	t.parent().find(".active").removeClass("active");
	t.toggleClass("active");
	t.parent().parent().next().find(".active").removeClass("active");
	subPanel.addClass("active");

	if (ww >= 960){
		var api = subPanel.closest('.builder-right-options-con').data('jsp');
		api.scrollToY(0,false);
		api.reinitialise();

		t.closest(".builder-right-sub-tabs").find(".builder-right-sub-tabs-marker").css({
			"transform" : "translateX(" + translateX + "px)"
		});
	} else {
		
		tp = $(this).parent();
		tt = $(this);

		$("html,body").animate({scrollTop: 0}, 200, function(){
			tp.find(".active").removeClass("active");
			tt.toggleClass("active");

			chosenTab = tt.find("a").html();

			tp.prev().html(chosenTab);
			tp.removeClass("open");

		});
	}


});



$(".builder-summary-edit").on("click touchstart",function(event){
	event.preventDefault();

	openTab = $(this).attr("href").replace('#','');

	rightCon.addClass("open").removeClass("hide");
	tabParent.find("[data-id='" + openTab + "']").trigger("click");

	tabParent.removeClass("hide");
	$(".builder-bottom-price-right").removeClass("inactive");

	if ($(window).width() < 768){
		leftCon.addClass("hide");
		bottomCon.addClass("preview");

		$(".builder-left-mobile-edit").slideUp();
	}
});

var summaried = false;

preview.on("click touchstart",function(e){
	e.preventDefault();
	tabParent.addClass("hide");
	rightCon.removeClass("open").toggleClass("hide");

	if (ww < 768){
		$(".builder-left-summary").show();
		leftCon.removeClass("hide");

		leftCon.animate({scrollTop: 0}, 300);

		if (!$(".builder-left-summary .builder-bottom-each").hasClass("toggleActive")){
			$(".builder-left-summary .builder-bottom-toggle").trigger("click");
		}

		$(".builder-bottom-buy").css({
			"top" : leftCon.find(".builder-right-title").outerHeight() + backHeight
		});

		$(".builder-bottom-models-con").hide();
		$(".builder-bottom-models-con .builder-right-engraving-selection span").eq(0).trigger("click");

		bottomCon.removeClass("preview");

		$(".builder-left-inner").css({
			"padding-top" : leftCon.find(".builder-right-title").outerHeight() + $(".builder-bottom-buy").outerHeight()
		});
	}
	else{
		previewTrigger = $(this).attr("data-id");

		rightCon.addClass("open").removeClass("hide");

		tabParent.find("[data-id='" + previewTrigger + "']").trigger("click");

		tabParent.removeClass("hide");
		$(".builder-bottom-price-right").removeClass("inactive");

	}

});


$(".builder-right-big-tabs-each").on("click touchstart",function(){
	t = $(this);
	thisId = t.attr("data-id");
	thisPanel = $("#" + thisId);
	panelParent = $(".builder-right-content");


	tabParent.find(".active").removeClass("active");
	t.toggleClass("active");

	panelParent.find(".current").removeClass("current");
	thisPanel.addClass("current");

	rightHeight = $(".builder-right-content").offset().top + thisPanel.find(".builder-right-title").outerHeight() + thisPanel.find(".builder-right-sub-tabs").outerHeight();

	builderArrows();

	thisPanel.find(".builder-right-options-each.chosen").trigger("click");



	if ( ww >= 960){

		// $(".builder-right-options-con").css({
		// 	"height" : wh - rightHeight,
		// 	"width" : rightCon.outerWidth()
		// });


thisPanel.find('.builder-right-options-con').jScrollPane();

$(".builder-right-content-each").css({
	"min-height" : wh - $(".builder-right-big-tabs").outerHeight() - thisPanel.find(".builder-right-title").outerHeight() - bottomConHeight
});

$(".builder-right-content-each-inner").css({
	"padding-top" : ""
});

}
else{
		//setTimeout(function(){
			//console.log(thisPanel.find(".builder-right-title").outerHeight());
			preview.css({
				// "top" : thisPanel.find(".builder-right-title").outerHeight() + thisPanel.find(".builder-right-subhead").outerHeight(),
				"top" : thisPanel.find(".builder-right-title").outerHeight() + backHeight,
				//"width" : $(".builder-right-con").outerWidth()
			});

			$(".builder-right-content").css({
				"padding-top" : thisPanel.find(".builder-right-title").outerHeight()
			});

			$(".builder-right-content-each-inner").css({
				// "padding-top" : bottomPreviewHeight + thisPanel.find(".builder-right-subhead").outerHeight()
				"padding-top" : bottomPreviewHeight
			});

			// var Rapi = $('.builder-right-options-con').jScrollPane().data().jsp;

			// Rapi.destroy();
			// $('.builder-right-options-con').css({
			// 	"width" : "",
			// 	"height" : ""
			// });

		//},100);

}


if ((ww >= 768) && (ww < 960)){


	$(".builder-right-content").css({
		"padding-top" : thisPanel.find(".builder-right-title").outerHeight()
	});

	$(".builder-right-content-each-inner").css({
		"padding-top" : bottomPreviewHeight,
		"padding-bottom" : bottomConHeight
	});

	$(".builder-right-content-each:not(#panel6)").css({
			// "min-height" : wh - thisPanel.find(".builder-right-title").outerHeight() - bottomPreviewHeight - bottomConHeight
			"min-height" : $(".builder-right-con").outerHeight() - thisPanel.find(".builder-right-title").outerHeight()
		});	

}


if (t.attr("id") == "tab-summary"){


	$(".builder-engraving-each").each(function(){
		if (!$(this).find("p").text().trim().length) {
			$(this).find("p").html("<em>Empty</em>");
		} 
	});


	if ($(window).width() < 768){


		tabParent.addClass("hide");
		rightCon.removeClass("open").toggleClass("hide");

		$(".builder-left-img").css({
			"height" : ""
		});

		$(".builder-left-summary").show();
		$(".builder-left-summary .builder-bottom-toggle").trigger("click");
		leftCon.removeClass("hide");


		leftCon.animate({scrollTop: 0}, 300);
		$(".builder-bottom-top-con").removeClass("hide");
		bottomCon.removeClass("preview");

		$(".builder-bottom-buy").css({
			"top" : leftCon.find(".builder-right-title").outerHeight() + backHeight
		});


		$(".builder-left-inner").css({
			"padding-top" : leftCon.find(".builder-right-title").outerHeight() + $(".builder-bottom-buy").outerHeight()
		});

	}


	if ((ww >= 768) && (ww < 960)){
		preview.addClass("hide");
		summaryHeight = $(".builder-right-con").outerHeight() - ( (thisPanel.offset().top - backHeight) * 2) - thisPanel.find(".builder-right-summary-inner").outerHeight();

			//console.log(summaryHeight) ; 

			$(".builder-right-summary").css({
				"height" : summaryHeight,
				"width" : "100%"
			});

		}

		if (ww >= 960){
			$(".builder-right-summary-con").css({
				"height" : wh - bottomConHeight - tabParent.outerHeight() - (parseInt($(".builder-right-summary-con").css("margin-top"))*2)
			});


			$(".builder-right-summary").css({
				"height" : $(".builder-right-summary-con").outerHeight() - thisPanel.find(".builder-right-title").outerHeight() - thisPanel.find(".builder-right-summary-text").outerHeight() ,
				"width" : "100%"
			});

			thisPanel.find('.builder-right-summary').jScrollPane({
				showArrows: false,
				autoReinitialise: true
			});


		}
	}
	else{
		preview.removeClass("hide");
	}


	if (currentPanel == "1"){
		$(".builder-right-control-left").addClass("inactive");
	}
	else{
		$(".builder-right-control-left").removeClass("inactive");
	}


	if ($(".builder-help-con").hasClass("open")){
		$(".builder-help-con, .global-overlay").removeClass("open");
		$(".builder-top-con").removeClass("help");
	}

	if (thisPanel.find(".builder-right-sub-tabs").length > 0){

		if (ww >= 960){
			if ($(this).hasAttr("visited")){
				visited = $(this).attr("visited");

				if (visited == "n"){
					thisPanel.find(".builder-right-sub-tabs li.active").trigger("click");
					$(this).attr("visited", "y");
				} 

			}

		} else {
			thisPanel.find(".builder-right-sub-tabs li:first-child").trigger("click");
		}

		
	}
	else{
		console.log("no");
		thisPanel.find(".builder-right-options").addClass("active");

		if (ww >= 960){
			thisPanel.find('.builder-right-options-con').jScrollPane();
		}

	}
}); 


//*Previous arrow*//
$(".builder-right-control-left").on("click",function(){
	if(! $(this).hasClass("inactive"))
	{
		if ($('#' + prevPanel).length > 0) { 
			$(".builder-right-control-left").removeClass("inactive");
			$(".builder-right-big-tabs-each[data-id='" + prevPanel + "']").trigger("click");
		}
	}
	
});


//*Next arrow*//
$(".builder-right-control-right").on("click",function(){

	if ($('#' + nextPanel).length > 0) { 
		$(".builder-right-control-right").removeClass("inactive");

		$(".builder-right-big-tabs-each[data-id='" + nextPanel + "']").trigger("click");
		
	}
	
});

$(".builder-help").on("click",function(){
	

	if ($(".builder-bottom-each").hasClass("open")){
		bottomCon.css("bottom", "");		
		$(".global-overlay").addClass("open");

		setTimeout(function(){
			$(".builder-help-con").toggleClass("open");
			$(".builder-top-con").toggleClass("help");
		},900);


	} else {
		$(".global-overlay, .builder-help-con").toggleClass("open");
		$(".builder-top-con").toggleClass("help");
	}

	$(this).closest(".builder-bottom-menu-con").slideToggle({
		direction: "down"
	});
	disableScroll();

});

$(".builder-help-prompt").on("click",function(){
	$(".builder-help-con, .global-overlay").removeClass("open");
	$(".builder-bottom-menu").removeClass("active");
	$(".builder-top-con").removeClass("help");
	//enableScroll();
});

$(".global-overlay").on("click touchstart",function(){
	$(this).removeClass("open");
	//enableScroll();


	if ($(".builder-bottom-models, .builder-bottom-specs").hasClass("open")){

		bottomCon.css({
			"bottom" : ""
		});

		bottomCon.find(".open").removeClass("open");
		bottomCon.find(".current").removeClass("current");
	}

	if ($(".builder-bottom-menu").hasClass("active")){
		$(".builder-bottom-menu").next().slideToggle({
			direction: "down"
		});

		$(".builder-bottom-menu").removeClass("active");
	}
});

$(".builder-left-msg-close-button, .builder-left-msg-close").on("click",function(event){
	event.preventDefault();
	$(".builder-left-msg").addClass("hide");
	//enableScroll();
});

$(".builder-left-msg").on("click",function(){
	$(this).addClass("hide");
	//enableScroll();
});

$(".global-select-div-selection").change(function(){
	t = $(this);
	nn = t.find("option:selected").text();
	t.prev().text(nn);
});


$(".builder-engraving-field-each").on("click",function(){
	$(this).addClass("selected");
});


$(".builder-right-options").on("click",function(event){

	if (! $(event.target).is(".builder-engraving-field-each")){
		$(".builder-engraving-field-each.selected").removeClass("selected");
	}
});


//Change font to serif/signature/
$(".builder-engraving-form-font li").on("click",function(){
	t = $(this);
	c = t.attr("data-value");
	id = t.attr("data-id");
	if(! t.hasClass("active"))
	{
		a = t.parent().find(".active");
		cc = a.attr("data-value");
		$("." + id).removeClass(cc).addClass(c);
		a.removeClass("active");
		t.addClass("active");

		buildEngravingText(t.attr("data-index"));

		if (c == "signature") {
			$("." + id).css({
				"font-size" : engravingRatio * signatureFont
			});
		} else {
			$("." + id).css({
				"font-size" : engravingFont
			});
		}
	}
});

$(".builder-right-content .builder-right-engraving-selection span").on("click",function(){
	$(this).parent().find(".active").removeClass("active");
	$(this).addClass("active");

	casebackParent = $(".builder-right-engraving-caseback-options");
	casebackShow = $("#" + $(this).attr("data-id"));
	if (! $(this).hasAttr("data-id")){
		if (($(this).hasClass('line-2'))){
			$("#img-engraving-2").removeClass("line-1");

			$(".builder-dial-engraving .builder-engraving-field-each:last-child").slideDown(500,function(){

				if (ww >= 960){
					var engravingApi = $(this).closest('.builder-right-options-con').data('jsp');
					engravingApi.reinitialise();
				}

				$(".builder-dial-engraving .builder-engraving-field-each:last-child").find("input").focus();
			});
		}
		else{
			if ($(window).width() < 768){
				formSummary = $("#summary-mobile-dial-2");
			} else if ($(window).width() >= 768) {
				formSummary = $("#summary-engraving-dial-2");
			}
			formSummary.find("p").html("<em>Empty</em>");
			$("#ea2").val("").trigger("keyup");
			$(".builder-left-img-engraving-2").html("");
			$("#img-engraving-2").addClass("line-1");
			$(".builder-dial-engraving .builder-engraving-field-each:last-child").slideUp();
		}
	} else {

		if($(this).attr("data-id") == 'builder-right-engraving-caseback-text')
		{
			$(".builder-engraving-text").trigger("keyup");
		}
		
		casebackParent.find(".showing").hide();
		casebackShow.addClass("showing").show();

		if (ww >= 960){
			var engravingApi = $(this).closest('.builder-right-options-con').data('jsp');
			engravingApi.reinitialise();
		}

	}
	
});





$(".builder-right-options-each").on("click",function(){
	t = $(this);
	thisOption = $("#" + $(this).attr("data-id"));
	thisImg = $(this).find("img").attr("src");
	thisName = $(this).attr("data-display");
  
  	//josh
  
  	//to test add cart
  	chosenProductID = $(this).attr("data-vid");
//   	console.log("josh test chosenVID " + chosenProductID);
  	//end
  
  	thisPrice = $(this).attr("id");
  	productPrice = $(this).attr("title");
//   	console.log(thisPrice);
	chosenPrice = thisPrice;
  
//   	//for first click
//     var joshtest = document.getElementById("joshtest");
//   	if (checkStrap == false && checkCaseback == false) {
//       productPrice = joshtest.getAttribute("title")
//       var totalprice = productPrice + thisPrice;
//       var productnumber = Number(productPrice);
//       var pricenumber = Number(thisPrice);
//       var totalnumber = productnumber + pricenumber;
//       totalnumber = totalnumber / 100;
//       totalnumber = parseFloat(totalnumber).toFixed(2);
//       joshtest2 = pricenumber;
//       if (joshtest.innerHTML != null) {
//           joshtest.innerHTML = "$" + totalnumber;
//       } else {
//         joshtest.innerHTML = 0;
//       }
//       checkStrap = this.getAttribute("data-id").includes("strap");
//       console.log("include strap --> " + this.getAttribute("data-id").includes("strap"));
//       checkCaseback = this.getAttribute("data-id").includes("caseback");
//       console.log("TESTESTESTEST ====== checkstrap --> " + checkStrap + "tesetstest ==== checkcaseback --> " + checkCaseback);
//       console.log("PRICEEEE == " + joshtest2);
//     }
  
//   	//second click for strap
//   	if (checkStrap == true && this.getAttribute("data-id").includes("caseback")) {
//       productPrice = joshtest.getAttribute("title")
//       var totalprice = productPrice + thisPrice;
//       var productnumber = Number(productPrice);
//       var pricenumber = Number(thisPrice);
//       var totalnumber = productnumber + pricenumber;
//       totalnumber = totalnumber / 100 + joshtest2;
//       totalnumber = parseFloat(totalnumber).toFixed(2);
//       if (joshtest.innerHTML != null) {
//           joshtest.innerHTML = "$" + totalnumber;
//       } else {
//         joshtest.innerHTML = 0;
//       }
//       checkStrap = false;
//       checkCaseback = true;
//       console.log("ENTERED HERE !!!!!" + joshtest2);
//     }
  
//   	//second click for caseback
//   	if (checkCaseback == true && this.getAttribute("data-id").includes("strap")) {
//       productPrice = joshtest.getAttribute("title")
//       var totalprice = productPrice + thisPrice;
//       var productnumber = Number(productPrice);
//       var pricenumber = Number(thisPrice);
//       var totalnumber = productnumber + pricenumber;
//       totalnumber = totalnumber / 100 + joshtest2;
//       totalnumber = parseFloat(totalnumber).toFixed(2);
//       joshtest2 = pricenumber;
//       if (joshtest.innerHTML != null) {
//           joshtest.innerHTML = "$" + totalnumber;
//       } else {
//         joshtest.innerHTML = 0;
//       }
//       checkStrap = true;
//       checkCaseback = false;
//       console.log("PRICEEEE == " + totalnumber);
//     }
  
//   	//if sameclick
//   	if (checkStrap == true || checkCaseback == true) {
//       productPrice = joshtest.getAttribute("title")
//       var totalprice = productPrice + thisPrice;
//       var productnumber = Number(productPrice);
//       var pricenumber = Number(thisPrice);
//       var totalnumber = productnumber + pricenumber;
//       totalnumber = totalnumber / 100;
//       totalnumber = parseFloat(totalnumber).toFixed(2);
//       if (joshtest.innerHTML != null) {
//           joshtest.innerHTML = "$" + totalnumber;
//       } else {
//         joshtest.innerHTML = 0;
//       }
//     }
  	
//       working copy
  	var joshtest = document.getElementById("joshtest");
      productPrice = joshtest.getAttribute("title")
      var totalprice = productPrice + thisPrice;
      var productnumber = Number(productPrice);
      var pricenumber = Number(thisPrice);
  
  		document.getElementById("tab-first").addEventListener("click", function(){
          joshtest3 = Number(0);
//           joshstrap = previousPrice;
          joshcaseback = Number(0);
//           console.log(joshstrap);
        });
  
  		document.getElementById("tab-last").addEventListener("click", function(){
          joshtest3 = Number(0);
//           joshcaseback = previousPrice;
          joshstrap = Number(0);
//           console.log(previousPrice);
        });
  
//   		console.log("TESTESTEST PP " + previousPrice);
  	  if (isNaN(previousPrice)) {
    	previousPrice = pricenumber;
//         console.log("entered pp");
      } else {
//         if (previousPrice != pricenumber) {
// //           pricenumber = Number(pricenumber + previousPrice);
//           previousPrice = Number(thisPrice);
//           console.log("entered pp if pn");
//         }
        previousPrice = Number(thisPrice);
//         console.log("entered pp");
      }
  	  if (isNaN(pricenumber)) {
      	pricenumber = 0;
      }
  
  if (this.getAttribute("data-id").includes("strap")) {
    joshstrap = pricenumber;
    joshcartstrap = this.getAttribute("data-vid");
  }
  if (this.getAttribute("data-id").includes("caseback")) {
      joshcaseback = pricenumber;
      joshcartcaseback = this.getAttribute("data-vid");
  } 
      var totalnumber = productnumber + pricenumber;
  	  var totalnumber2 = totalnumber;
      totalnumber = totalnumber / 100;
      totalnumber = parseFloat(totalnumber).toFixed(2);
  	  joshtest2 = Number(productnumber + joshstrap + joshcaseback);
  	  joshtest2 = joshtest2 / 100;
  	  joshtest2 = parseFloat(joshtest2).toFixed(2);
  	  joshtest3 = Number(totalnumber);
  	  joshtest3 = parseFloat(joshtest3).toFixed(2);
      if (joshtest.innerHTML != null) {
//           joshtest.innerHTML = "$" + totalnumber;
          joshtest.innerHTML = "USD$" + joshtest2;
      } else {
        joshtest.innerHTML = 0;
      }
      
  	//end

	t.closest(".builder-right-options-con").find(".chosen").removeClass("chosen");
	t.toggleClass("chosen");

	if ($(this).hasAttr("data-id")) {

		tid = $(this).attr("data-id").split("-");
		values[tid[0].capitalizeFirstLetter()] = $(this).attr("data-title");

		leftImgParent = $("#img-" + $(this).attr("data-id").split("-")[0]); 

		if (ww >= 768){
			thisSummary = $("#summary-" + $(this).attr("data-id").split("-")[0]);
		} else if (ww < 768){
			thisSummary = $("#summary-mobile-" + $(this).attr("data-id").split("-")[0]);

		}

		leftImgParent.find(".chosen").removeClass("chosen");
		leftImgParent.find(thisOption).addClass("chosen");


	thisSummary.find("img").attr("src", thisImg); //*update summary*//
	thisSummary.find("p").html(thisName);

	if ($(this).hasAttr("data-color")){ //Switch color of text//
		txtColor = $(this).attr("data-color");

		if (txtColor == "white"){
			console.log(txtColor+"DAS");
			$(".builder-left-img-engraving-each").removeClass("black");
		}
		else if (txtColor == "black"){
			$(".builder-left-img-engraving-each").addClass("black");
		}
	}
}


});

$(".builder-right-engraving-caseback-options .builder-right-options-each").on("click",function(){
	t = $(this);
	title = t.attr("data-title");
	img = t.attr("data-thumbnail");
	$("#summary-mobile-back p,#summary-engraving-back p").html('<img src="'+img+'">' + title);
	values['Case Back'] = title + "(Curated)";
});


$("#builder-right-engraving-caseback-design .builder-right-options-each").on("click",function(){
	casebackChosen = $(this).find($(".builder-right-options-name span")).html();
	$("#summary-engraving-back").find("p").html(casebackChosen);
}); 

// Show black or white markers according to color of dial//
$(".builder-right-content-dial .builder-right-options-each").on("click",function(){
	black = $(this).attr("data-black");
	white = $(this).attr("data-white");
	markersDiv = $(".builder-right-content-markers");
	markersImgDiv = $("#panel3");
	chosenId = markersImgDiv.find(".chosen").attr("id");
	//chosenColor = chosenId.split("-")[3];
	//chosenString = chosenId.split("-")[3];
	if ((black == 1) && (white == 0)){ //*Show black markers*//
		markersDiv.find(".blackandwhite").hide();
		markersDiv.find(".white").hide();
		markersDiv.find(".black").show();

		opp = markersImgDiv.find(".chosen").attr("data-black");
		$("#" + opp).trigger("click");

		// if ((chosenColor !== 'undefined') && (chosenColor == "white")){

			
		// 	changeColor = "#" + chosenId.replace(chosenString, "black");
		// 	newChosen = chosenId.replace(chosenString, "black");

		// 	markersImgDiv.find(".chosen").removeClass("chosen");
		// 	markersImgDiv.find(changeColor).addClass("chosen");
		// 	markersDiv.find(".chosen").removeClass("chosen");
		// 	markersDiv.find("[data-id='" + newChosen + "']").addClass("chosen");
		// }
	}

	else if ((white == 1) && (black == 0)){ //*Show white markers*//
		markersDiv.find(".blackandwhite").hide();
		markersDiv.find(".black").hide();
		markersDiv.find(".white").show();

		opp = markersImgDiv.find(".chosen").attr("data-white");
		$("#" + opp).trigger("click");

		// if ((chosenColor !== 'undefined') && (chosenColor == "black")){
		// 	changeColorW = "#" + chosenId.replace(chosenString, "white");
		// 	newChosenW = chosenId.replace(chosenString, "white");

		// 	markersImgDiv.find(".chosen").removeClass("chosen");
		// 	markersImgDiv.find(changeColorW).addClass("chosen");
		// 	markersDiv.find(".chosen").removeClass("chosen");
		// 	markersDiv.find("[data-id='" + newChosenW + "']").addClass("chosen");
		// }
	}
});

$(".builder-engraving-form input").keyup(function(){
	
	a = $(this).val();

	// if(a.length==0)
	// {
	// 	a = "<em>Empty</em>";
	// }

	textId = $("." + $(this).attr("data-id"));
	
	charCount = $(this).val().length;

	textId.html(a); 
	$(this).parent().find(".builder-engraving-form-limit span").text(charCount);

	buildEngravingText($(this).attr("data-index"));
});

$(".builder-engraving-form textarea").keyup(function(){
	a = $(this).val();

	if(a.length==0)
	{
		a = "<em>Empty</em>";
	}
	else
	{
		values['Case Back'] = a;
	}
	charCount = $(this).val().length;
	$(this).parent().find(".builder-engraving-form-limit span").text(charCount);
	$("#summary-mobile-back p,#summary-engraving-back p").html(a);
});


$(document).keyup(function(e) { 
        if (e.keyCode == 27) { // esc keycode
        	if ($("#bottom-specs, #bottom-models").hasClass("current")){
        		bottomCon.css({
        			"bottom" : ""
        		});

        		bottomCon.removeClass("open");
        		$(".builder-bottom-inner").removeClass("active");
        		bottomCon.find(".open").removeClass("open");
        		bottomCon.find(".current").removeClass("current");
        		$(".global-overlay").removeClass("open");
        	}
        }
    });


var sideSlick = false; 

$(document).ready(function() {


	$('.builder-img-trigger').magnificPopup({
		type: 'inline',
		removalDelay: 500,
		closeBtnInside: false,
		callbacks:{
			open: function(){


				$("body").toggleClass("img-open");

				if (sideSlick == false){

					console.log("open");


					$(".builder-img-pu-img").slick({
						infinite: true,
						fade: false,
						arrows: true,
						slidesToShow: 2,
						slidesToScroll: 1,
						dots: true,
						responsive: [
						{
							breakpoint: 768,
							settings:{
								slidesToShow: 1,
								slidesToScroll: 1,
							}
						}
						]
					});

					sideSlick = true;

				}

			},
			close: function(){
				$("body").removeClass("img-open");
			}
		}
	});

	$('.builder-dial-popup').magnificPopup({
		type: 'inline',
		removalDelay: 500,
		closeBtnInside: false,
		callbacks:{
			open: function(){
				$("body").toggleClass("img-open");
			},
			close: function(){
				$("body").removeClass("img-open");
			}
		}
	});
	console.log('%c Design & Web Development by http://360and5.com ', 'background: #222; color: #fff');
});


$(".builder-add-to-cart").on("click",function(event){
	event.preventDefault();
	variant_id = $(this).attr("data-id");
	console.log(values);
	args = {quantity:1,id:variant_id, properties:values};
	$.ajax({
		type: 'POST',
		url: '/cart/add.js',
		data: args,
		dataType: 'json',
		success:function(line_item){
			location = "/cart";
		}
	});
});

$(".builder-bottom-models-con .builder-right-engraving-selection span").on("click",function(){
	$(this).parent().find(".active").removeClass("active");
	$(this).addClass("active");
	$(".builder-bottom-models-section-each").hide();
	$("#" + $(this).attr("data-id")).show();
});


//josh test price

var selectedID;

$(".builder-right-options-each").on("click",function(){
  	t2 = $(this);
	thisOption2 = $("#" + $(this).attr("data-id"));
	thisImg2 = $(this).find("img").attr("src");
	thisName2 = $(this).attr("data-display");
  	tprice = $(".testprice").attr('id');
  	tprice2 = $(this).find(".testprice").attr('id');
  
// 	console.log("CLICKED WOOHOO");
//   	console.log(tprice2);
  
  	tID = $(this).find(".test-add-to-cart").attr('data-id');
    selectedID = tID;
//     console.log("var id = " + selectedID);
	
});

$(".test-add-to-cart").on("click",function(event){
	event.preventDefault();
	variant_id = $(this).attr("data-id");
// 	console.log(values);
	args = {quantity:1,id:variant_id, properties:values};
	$.ajax({
		type: 'POST',
		url: '/cart/add.js',
		data: args,
		dataType: 'json',
		success:function(line_item){
// 			location = "/cart";
		}
	});
//   	var targetdiv = document.getElementById("test-add-to-cart");
//   	targetdiv.innerHTML = "Added Successfully";
  
	t = $(this);
//   	t.hide();
//   	t.innerHTML("ADDED");
  
  	var thisOption = $($(this).attr("title"));
//   	console.log(""+thisOption);
//   	var thisDoc = document.getElementById(""+thisOption);
//   	thisDoc.remove();
//   	if ($(this).").includes("caseback",0)
  
//   	if ($(this).attr("title").includes("ruthenium",0) {
//     	$("#add-caseback-" + $(this).attr("title")).hide();  
// 	}
                 
//     console.log($(this).attr("title").includes("ruthenium",0));
       var caseback = $(this).attr("title").includes("ruthenium",0);
  if (caseback) {
    $("#add-caseback-" + $(this).attr("title")).hide();
    $("#add-success-" + $(this).attr("title")).show();
  } else {
    $("#add-strap-" + $(this).attr("title")).hide();
    $("#add-success-" + $(this).attr("title")).show();
  }
    
//   	thisDoc.innerHTML("ADDED");
//   $(thisOption).html('New title to display');
  
//   $(".test-add-to-cart").hide();
//   $(".add-to-cart-success").show();
});

function returnSelectedID(){

	if (selectedID) {
    	return selectedID;
    } else {
    	return 0;
    }
}

// $(".test-change").on("click",function(event){
// 	this.next("em").replaceWith("added");
// }

$(".test-add-to-cart-2items").on("click",function(event){
	event.preventDefault();
	variant_id = $(this).attr("data-id");
// 	console.log(values);
  	var joshtestcart = document.getElementById("joshtest");
  	variant_id2 = joshtest.getAttribute("data-id"); 
//   	console.log("varid2 = " + variant_id2);
  	//id of selected product
  	var joshtestcart2 = document.getElementById("joshtestcart33");
//   	variant_id3 = joshtestcart2.getAttribute("data-id");
  	variant_id3 = joshcartstrap;
//   	console.log("VARIANT ID 3 ==== " + variant_id3);
  	//test selected item variable
  	var joshtestcartstrap = document.getElementById("joshcartcaseback");
//   	variant_id4 = joshtestcartstrap.getAttribute("data-id");
  	variant_id4 = joshcartcaseback;
  
  	//remove geometric input for signature series
  	var removeGeometricInput = false;
  	var joshGeometricRemove = document.getElementById("joshRemoveSignatureGemoetric");
  	removeGeometricInput = joshGeometricRemove.getAttribute("data-id").includes("Signature");
  	//end
  
	args = {quantity:1,id:variant_id, properties:values};
  	args2 = {quantity:1,id:variant_id3};
  	args3 = {quantity:1,id:variant_id4};
  	console.log("vid === " + variant_id4);
  	console.log("args 3 === " + args3);
  	
	$.ajax({
		type: 'POST',
		url: '/cart/add.js',
		data: args,
      	async: false,
		dataType: 'json',
		success:function(line_item){
// 			location = "/cart";
//           	console.log("success!!!");
		}
	});
  if(removeGeometricInput == false) {
  	$.ajax({
		type: 'POST',
		url: '/cart/add.js',
		data: args3,
      	async: false,
		dataType: 'json',
		success:function(line_item){
// 			location = "/cart";
//           	console.log("success2!!");
		}
	});
  }
  	$.ajax({
		type: 'POST',
		url: '/cart/add.js',
		data: args2,
      	async: false,
		dataType: 'json',
		success:function(line_item){
			location = "/cart";
//           	console.log("success2!!");
		}
	});
});

$(".joshtotal-add-to-cart").on("click",function(event){
	event.preventDefault();
	variant_id = $(this).attr("data-id");
// 	console.log(values);
	args = {quantity:1,id:variant_id, properties:values};
	$.ajax({
		type: 'POST',
		url: '/cart/add.js',
		data: args,
		dataType: 'json',
		success:function(line_item){
			location = "/cart";
		}
	});
});